<template>
  <el-row :gutter="20" class="InformationInquiryContent">
    <el-col :span="contentCol" v-for="item in dataList" :key="item.id">
      <div class="content" @click="page(item)">
<!--        <a target="_blank" :href="Url">-->
        <el-link :underline="false" class="itemLink">
          <svg-icon style="font-size: 36px;color: #b71c1c;" :icon-class="item.icon_class"></svg-icon>
          <p :class="[(item.title === '上海市民间收藏文物鉴定咨询推荐单位名单' || item.title === '全国文物商店、文物拍卖企业名单') ? 'needPadding' : '']" style="height: 40px;margin: 0;margin-top: 20px;font-size: 16px;color: #000;">{{ item.title }}</p>
        </el-link>
<!--        </a>-->
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "InformationCard",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { Url: "#" };
  },
  computed: {
    contentCol() {
      if (this.dataList.length > 4) {
        return 6;
      } else {
        return 24 / this.dataList.length;
      }
    },
  },
  methods: {
    page(val) {
      if (val.only == 1) {
        if (val.path == "#") {
          this.Url=val.url
          window.open(val.url, "_blank");
        } else {
          let routerJump = this.$router.resolve({
            path: val.path,
          });
          window.open(routerJump.href, "_blank");
        }
      } else {
        let routerJump = this.$router.resolve({
          path: val.path,
          query: {
            title: val.title,
            type: val.type,
          },
        });
        window.open(routerJump.href, "_blank");
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../styles/theme";
.InformationInquiryContent {
  /*margin: 0 12px 25px 0;*/
  .content {
    text-align: center;
    cursor: pointer;
    height: 112px;
    /*padding: 10px;*/
    background: rgb(242, 242, 242);
    border: 1px solid #dddddd;
    border-radius: 4px;
    width: 100%;
    margin-bottom: 11px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /*margin: 15px auto 0px;*/
    i {
      width: 1em;
      height: 1em;
      font-size: 36px;
      vertical-align: -0.15em;
      fill: currentColor;
      color: @theme-color;
    }
    p {
      font-size: 16px;
    }
  }
  .content:hover {
    background-color: #f8e8e8;
    border-radius: 5px;
    border-color: @theme-color;
  }
  /deep/ .el-link{
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    text-decoration: none;
    outline: none;
    cursor: pointer;
    padding: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  /deep/ .el-link.el-link--default {
    color: #606266;
  }
}
  .needPadding{
    padding: 0 10px !important;
  }
</style>
